<template>
  <div
    v-if="discountType === 'student'"
    class="flex flex-col md:flex-row md:items-center"
  >
    <StudentDiscountCTA
      class="mb-12 md:mb-0 md:mr-12"
      v-bind="attrs"
      :ctaLabel
      @click="handleClick(ctaLabel)"
    />

    <EducatorDiscountCTA
      v-if="secondaryCtaLabel"
      class="mb-12 md:mb-0"
      v-bind="attrs"
      :ctaLabel="secondaryCtaLabel"
      @click="handleClick(secondaryCtaLabel)"
    />
  </div>

  <MilitaryDiscountCTA
    v-if="discountType === 'military'"
    v-bind="attrs"
    :ctaLabel
    @click="handleClick(ctaLabel)"
  />
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import type { BlockProps } from '@backmarket/nuxt-layer-cms/models/content-block'

import EducatorDiscountCTA from './components/EducatorDiscountCTA/EducatorDiscountCTA.vue'
import MilitaryDiscountCTA from './components/MilitaryDiscountCTA/MilitaryDiscountCTA.vue'
import StudentDiscountCTA from './components/StudentDiscountCTA/StudentDiscountCTA.vue'

const props = defineProps<{
  discountType: 'military' | 'student'
  tracking: Required<BlockProps>['tracking']
  ctaLabel: string
  secondaryCtaLabel?: string
}>()

/**
 * note: attributes are not automatically inherited when there are multiple root notes.
 * this allows the parent DiscountBanner to pass attributes (such as class) to these components
 * see https://vuejs.org/api/component-instance.html#attrs
 */
const attrs = useAttrs()

const { trackClick } = useTracking()

function handleClick(name: string) {
  trackClick({
    ...props.tracking,
    name,
  })
}
</script>
